import { defineMessages } from "react-intl"

export const messages = defineMessages({
    "updated_at": {
        id: "bundle.listing.filters.date.updated_at",
        defaultMessage: "Updated date",
    },
    "is_archived": {
        id: "bundle.listing.headers.show_archived",
        defaultMessage: "Show archived",
    },
    "bundle_label": {
        id: "bundle.listing.headers.product_label",
        defaultMessage: "Bundle label",
    },
    "bundle_title": {
        id: "bundle.listing.headers.product_title",
        defaultMessage: "Bundle title",
    },
    "bundle_sku": {
        id: "bundle.listing.headers.product_sku",
        defaultMessage: "Bundle sku",
    },
    "product_manufacturer_sku": {
        id: "bundle.listing.headers.product_manufacturer_sku",
        defaultMessage: "Product Manufacturer sku",
    },
    "short_description": {
        id: "bundle.listing.headers.product_short_description",
        defaultMessage: "Bundle Short Description",
    },
    "default_price": {
        id: "bundle.listing.headers.default_price",
        defaultMessage: "Bundle Price",
    },
})


// WEBPACK FOOTER //
// ./src/common/search-filter/search/bundleFilters/messages.ts